import { validatorStringTextNumbersSymbolsExt } from "./validatorStringTextNumbersSymbolsExt";

export const validatorCompanyName = validatorStringTextNumbersSymbolsExt;
